export const PERSONALIZATION_ID = "personalizationID";
